import { render, staticRenderFns } from "./MobileOrder.vue?vue&type=template&id=46b67679&scoped=true"
import script from "./MobileOrder.vue?vue&type=script&lang=js"
export * from "./MobileOrder.vue?vue&type=script&lang=js"
import style0 from "./MobileOrder.vue?vue&type=style&index=0&id=46b67679&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b67679",
  null
  
)

export default component.exports